
import React from 'react';
import { motion } from 'framer-motion';

export const HUDOverlay: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none z-[100] hidden lg:flex flex-col justify-between p-6 overflow-hidden">


      {/* Top HUD */}
      <div className="flex justify-between items-start">
        <div className="flex flex-col gap-1 border-l-2 border-accent pl-3">
          <span className="text-[10px] font-black uppercase tracking-[0.3em] text-accent/50">Mission Status</span>
          {/* <span className="text-xs font-mono font-bold text-accent animate-pulse">ACTIVE_RECONNAISSANCE</span> */}
        </div>
        <div className="flex flex-col items-end gap-1 border-r-2 border-accent pr-3">
          <span className="text-[10px] font-black uppercase tracking-[0.3em] text-accent/50">Agent Health</span>
          {/* <div className="flex gap-1 mt-1">
            {[1, 2, 3, 4, 5].map(i => (
              <motion.div 
                key={i} 
                initial={{ opacity: 0.3 }}
                animate={{ opacity: [0.3, 1, 0.3] }}
                transition={{ duration: 2, delay: i * 0.2, repeat: Infinity }}
                className="w-4 h-1 bg-accent rounded-full" 
              />
            ))}
          </div> */}
        </div>
      </div>

      {/* Bottom HUD */}
      <div className="flex justify-between items-end">
        <div className="flex flex-col gap-2 max-w-[200px]">
          <div className="h-[2px] w-full bg-white/10" />
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className="text-[10px] font-black uppercase tracking-[0.3em] text-accent/50">Confidence Score Above</span>
          <span className="text-2xl font-black text-white italic">99.8%</span>
        </div>
      </div>

      {/* Corners Decoration */}
      <div className="absolute top-0 left-0 w-20 h-20 border-t-2 border-l-2 border-white/5" />
      <div className="absolute top-0 right-0 w-20 h-20 border-t-2 border-r-2 border-white/5" />
      <div className="absolute bottom-0 left-0 w-20 h-20 border-b-2 border-l-2 border-white/5" />
      <div className="absolute bottom-0 right-0 w-20 h-20 border-b-2 border-r-2 border-white/5" />
    </div>
  );
};
